import { useContext } from "react";
import { ShowContent } from "../../../components";
import AuthContext from "../../../context/AuthContext";
import ChemicalTrackerClient from "./ChemicalTrackerClient";
import ChemicalTrackerAdmin from "./ChemicalTrackerAdmin";

export const ChemicalTrackerPage = () => {
  const { idRole, isLoading } = useContext(AuthContext);

  const content =
    idRole === 3 ? <ChemicalTrackerClient /> : <ChemicalTrackerAdmin />;

  return <ShowContent error={""} isLoading={isLoading} content={content} />;
};
